import { Box } from "@mui/material";
import { useRef } from "react";
import ModalComp from "./ModalComp";

export default function MorePrograme({ children, data }) {
  const img = useRef();
  const profile = useRef();

  return (
    <ModalComp
      fullScreen
      title="운동프로그램"
      button={<div>{children}</div>}
      divider
    >
      <Box style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          className="p-3 justify-center flex flex-col items-center mb-10"
          style={{ flex: "1" }}
        >
          <Box className="w-full pb-10 mb-10 flex justify-center items-center border-b-4">
            <img
              className="w-4/5"
              src={data.icon}
              alt=""
              ref={img}
              onError={() => {
                img.current.src = "/img/program/no_img.png";
              }}
            />
          </Box>
          <Box>
            <p className="text-center text-slate-500">{data.engName}</p>
            <p className="text-center text-2xl">{data.korName}</p>
          </Box>
          <Box className="flex items-center w-full justify-end px-3 my-3">
            <p className="mr-1 text-sm text-slate-400">Created by </p>
            <p className="text-center mr-[4px] text-slate-700">
              {data.creator}
            </p>
            <div className="w-10 rounded-full overflow-hidden">
              <img
                src={data.creatorImg}
                alt=""
                ref={profile}
                onError={() => {
                  profile.current.src = "/img/program/user.png";
                }}
              />
            </div>
          </Box>
          <Box className="px-5 mt-7 mb-5">
            {data.value && (
              <p
                dangerouslySetInnerHTML={{
                  __html: data.value.replaceAll("\n", "<br />"),
                }}
              ></p>
            )}
          </Box>
        </Box>
      </Box>
    </ModalComp>
  );
}
